import { Pipe, PipeTransform } from '@angular/core';
import { NormalizerHelper } from 'src/app/core/helpers/normalizer.helper';
import { NullSafe } from 'src/app/core/types/null-safe.type';

@Pipe({
  name: 'cpfCnpj',
})
export class FormatCpfCnpjPipe implements PipeTransform {
  transform(value: NullSafe<string>): string {
    return NormalizerHelper.formatCpfCnpj(value);
  }
}
